import { chartColours } from '../../themes/colours';
import { gis2QueryUrl, gis2TileUrl } from '../../utils/urls.js';
import { CIRCLE_RADIUS, CIRCLE_STROKE_WIDTH } from '../layerDefsConfig';

const modelledNo2Layer = {
    layer: {
        id: 'modelled-no2',
        type: 'raster',
        layout: {
            visibility: 'none',
        },
    },
    source: {
        id: 'modelled-no2',
        type: 'raster',
        tiles: [gis2TileUrl('Air_Quality_map_service_NO2_2022')],
    },
    labels: {
        parent: 'Modelled NO2',
    },
    filters: {
        filterByChildren: false,
    },
    category: 'environment',
    noColourPicker: true,
    info: {
        shortDescription:
            'Annual average concentrations of nitrogen dioxide (NO2) across London in 2022.',
        longDescriptionTitle: 'Modelled NO2 Layer Information',
        longDescription:
            'This map layer shows the annual average concentrations of nitrogen dioxide (NO2) across London in 2022 as modelled by the London Atmospheric Emissions Inventory (2022). The legend below increases in increments of 3 μg m-3, the legal limit is 40 μg m-3. For more information please visit: https://data.london.gov.uk/air-quality/',
    },
};

const lowEmissionNeighbourhoodsLayer = {
    layer: {
        id: 'low-emission-neighbourhoods',
        type: 'fill',
        paint: {
            'fill-color': chartColours.ldnDkPink,
            'fill-opacity': 0.7,
            'fill-outline-color': '#000000',
        },
        layout: {
            visibility: 'none',
        },
    },
    source: {
        id: 'low-emission-neighbourhoods',
        type: 'geojson',
        data: gis2QueryUrl('Air_Quality_map_service_01', 12),
    },
    labels: {
        parent: 'Low Emission Neighbourhoods',
    },
    filters: {
        filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: 'environment',
    popupAttributes: ['sitename', 'classification'],
    orderNumber: 1,
    info: {
        shortDescription:
            'A Low Emission Neighbourhood (LEN) is an area-based scheme that includes a package of measures focused on reducing emissions (and promoting sustainable living more generally).',
        longDescriptionTitle: 'Low Emission Neighbourhoods Layer Information',
        longDescription:
            'A Low Emission Neighbourhood (LEN) is an area-based scheme that includes a package of measures focused on reducing emissions (and promoting sustainable living more generally). A LEN is delivered by a borough with support from Transport for London (TfL), the Greater London Authority (GLA) and the local community.',
    },
};

const airQualityFocusAreaLayer = {
    layer: {
        id: 'air-quality-focus-area',
        type: 'fill',
        paint: {
            'fill-color': chartColours.ldnDkPink,
            'fill-opacity': 0.7,
            'fill-outline-color': '#000000',
        },
        layout: {
            visibility: 'none',
        },
    },
    source: {
        id: 'air-quality-focus-area',
        type: 'geojson',
        data: gis2QueryUrl('Air_Quality_map_service_01', 13),
    },
    labels: {
        parent: 'Air Quality Focus Area',
    },
    filters: {
        filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: 'environment',
    popupAttributes: ['sitename'],
    orderNumber: 3,
    info: {
        shortDescription:
            'These are locations that not only exceed the EU annual mean limit value for NO2 but are also locations with high human exposure.',
        longDescriptionTitle: 'Air Quality Focus Area Layer Information',
        longDescription:
            "Areas designated as an Air Quality Focus Area. These are locations that not only exceed the EU annual mean limit value for NO2 but are also locations with high human exposure. For more information about action being taken to tackle the pollution in this area please click on an area to read it's Borough Air Quality Action Plan.",
    },
};

const airQualityMonitoringSitesLayer = {
    layer: {
        id: 'air-quality-monitoring-sites',
        type: 'circle',
        paint: {
            'circle-color': '#9E0059',
            'circle-stroke-width': CIRCLE_STROKE_WIDTH,
            'circle-stroke-color': '#fff',
            'circle-radius': CIRCLE_RADIUS,
        },
        layout: {
            visibility: 'none',
        },
    },
    source: {
        id: 'air-quality-monitoring-sites',
        type: 'geojson',
        data: gis2QueryUrl('Air_Quality_map_service_01', 1),
    },
    labels: {
        parent: 'Air Quality Monitoring Sites',
    },
    filters: {
        filterByChildren: false,
    },
    filterBySelectedRegion: true,
    category: 'environment',
    popupAttributes: ['sitename', 'classification'],
    orderNumber: 2,
    info: {
        shortDescription:
            'Includes regulatory monitoring stations as well as the new network of mid-cost sensors.',
        longDescriptionTitle: 'Air Quality Monitoring Sites Layer Information',
        longDescription:
            'Includes regulatory monitoring stations, City Airport monitoring as well as the new network of mid-cost sensors through the Breathe London programme. Click each site for more information.',
    },
};

export const environmentLayersBase = {};

export const environmentLayersPoly = {
    'modelled-no2': modelledNo2Layer,
    'low-emission-neighbourhoods': lowEmissionNeighbourhoodsLayer,
    'air-quality-focus-area': airQualityFocusAreaLayer,
    'air-quality-monitoring-sites': airQualityMonitoringSitesLayer,
};

export const environmentLayersPoint = {};
